<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
export default {
  mixins: [Api, Sabit],
  props: ["TanimId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
    };
  },
  methods: {
    Get() {
      let Filter = "&TanimId=" + this.TanimId;
      this.ActionsFilterGet({ Service: "StrKontrolIsbirlikci", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
};
</script>
<template>
  <div>
    <table class="table mb-0" v-if="TableData.length != 0">
      <thead style="background: #2a3042; color:#ffffff !important;">
        <tr>
          <th scope="col">{{ $t("StrKontrolIsbirlikci.AltTable.BirimAdis") }}</th>
          <th scope="col">{{ $t("StrKontrolIsbirlikci.AltTable.Tip") }}</th>
          <th scope="col">{{ $t("StrKontrolIsbirlikci.AltTable.Islem") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="TableDataVerileri in TableData" :key="TableDataVerileri.Id">
          <td>{{ TableDataVerileri.BirimAdis.join(", ") }}</td>
          <td>
            <div v-if="TableDataVerileri.Tip == '1'">İşbirliği Yapılacak</div>
            <div v-else>Sorumlu</div>
          </td>
           <td style="width: 85px; text-align: center; vertical-align: middle;">
              <b-button-group>
                <b-button variant="primary" @click="$emit('Id', TableDataVerileri)"><i class="fas fa-pencil-alt"></i></b-button>
                <b-button variant="danger" @click="Delete('StrKontrolIsbirlikci', TableDataVerileri.Id)"><i class="fas fa-trash-alt"></i></b-button>
              </b-button-group>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
